<template>
  <Modal :color="ConfigModalsColor" title="Shopping Cart" v-if="cart_modal" :visible="true"
    @close="store.SetState('cart_modal', false)" max_width="960">
    <v-card-text>
      <!--Desktop View-->
      <v-data-table v-if="!is_mobile" :loading="loading" :items="cart_items" :headers="headers_desktop">
        <template v-slot:item="{ item, index }">
          <tr>
            <td>
              <div class="d-flex align-center">
                <img @click="ViewProduct(item.product)" class="table-img" :src="ProductImage(item.product)" width="50"
                  alt="product img">
                <div @click="ViewProduct(item.product)" class="table-txt is-desktop-view">{{ item.product.name }}</div>
              </div>
            </td>
            <td>
              <div class="d-inline-flex">
                <v-btn @click="item.quantity--" variant="elevated" icon="mdi-minus" size="small"
                  :disabled="item.quantity <= 1" />
                <v-btn variant="text"><b>{{ item.quantity }}</b></v-btn>
                <v-btn @click="item.quantity++" variant="elevated" icon="mdi-plus" size="small" />
              </div>
            </td>
            <td>
              <ul class="pa-1">
                <li style="font-size:12px" v-for="ds in item.datasets.filter((x: any) => x.selected)" :key="ds.id">
                  <span class="clip-text-1-lines">{{ Accessory(item,ds).name }}</span>
                </li>
                <li v-if="item.datasets.filter((x: any) => x.selected).length < 1">None</li>
              </ul>
            </td>
            <td>
              <v-btn rounded="pill" @click="RemoveItem(index)" prepend-icon="mdi-trash-can" color="error" size="small"
                variant="tonal">Remove</v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>

      <!--Mobile View-->
      <v-data-table v-if="is_mobile" :loading="loading" :items="cart_items" :headers="headers_mobile">
        <template v-slot:item="{ item, index }">
          <tr>
            <td>
              <div @click="ViewProduct(item.product)" class="table-txt">{{ item.product.name }}</div>
            </td>
            <td>
              <v-btn @click="RemoveItem(index)" icon="mdi-trash-can" color="error" size="small" variant="tonal" />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <template #footer>
      <v-spacer />
      <CheckoutBtn />
      <v-spacer />
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import Modal from "@/components/misc/Modal.vue"
import CheckoutBtn from "@/components/cart/CheckoutBtn.vue"

const store = useGlobalsStore()
const {
  is_mobile,
  cart_items,
  cart_modal,
  ConfigModalsColor
} = storeToRefs(store)

const loading = ref(false)

const headers_desktop = ref([
  { title: 'Copier' },
  { title: 'Qty.' },
  { title: 'Accessories' },
  { title: 'Manage' },
])

const headers_mobile = ref([
  { title: 'Copier' },
  { title: 'Manage' },
])

function Accessory(this_item:any,dataset: any) {
  const this_accessories = this_item.accessories ?? [];
  return this_accessories.find((a: any) => a.id === dataset.accessory_id) || { name: '' }
}

function RemoveItem(index: number) {
  const items = [...cart_items.value]
  items.splice(index, 1)
  if (items.length < 1) {
    store.ClearQuoteValues()
  }
  store.SetCartItems(items)
}

function ViewProduct(product: any) {
  store.SetState('view_product', product)
}

const ProductImage = store.ProductImage
</script>

<style scoped>
.table-txt {
  color: #164185;
  cursor: pointer;

  &:hover {
    color: #095ee3;
  }

  &.is-desktop-view {
    margin-left: 10px;
  }
}
</style>
